export default __webpack_public_path__ + "static/media/amazing-kraver.9fc2735e.svg";